import { match } from 'path-to-regexp'

type WithLocaleType = { locale: string; token: string }
type NoLocaleType = { token: string }

const matchWithLocale = match<WithLocaleType>(
  '/:locale/reset-password/:token',
  {
    end: true,
    sensitive: true,
    decode: decodeURIComponent,
  },
)

const matchNoLocale = match<NoLocaleType>('/reset-password/:token', {
  end: true,
  sensitive: true,
  decode: decodeURIComponent,
})

export const extractResetToken = (): string | null => {
  if (typeof window === 'undefined') {
    return null
  }

  const pathname = window.location.pathname
  const result = matchWithLocale(pathname) ?? matchNoLocale(pathname)

  return result ? result.params.token : null
}
